import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../hostel/HostelReportTabs.css";
import usePrivateLink from "../config/usePrivateLink";

const REPORT_TABS = [
  {
    path: "/hostel/reports",
    label: "Overview",
    icon: "ri-dashboard-line",
  },
  {
    path: "/hostel/credit/debit/report",
    label: "Credit Debit Report",
    icon: "ri-exchange-dollar-line",
  },
  {
    path: "/hostel/fee/report",
    label: "Fee Report",
    icon: "ri-money-rupee-circle-line",
  },
  {
    path: "/hostel/expense/report",
    label: "Expense Report",
    icon: "ri-wallet-3-line",
  },
  {
    path: "/hostel/fee/due/report",
    label: "Due Fee Report",
    icon: "ri-error-warning-line",
  },
  {
    path: "/hostel/student/month/report",
    label: "Hostel Student Report",
    icon: "ri-calendar-line",
  },
];

export default function HostelReportTabs() {
  const location = useLocation();
  const hasAccess = usePrivateLink();

  return (
    <div className="card border-0 shadow-sm mb-4">
      <div className="card-body p-2">
        <div className="hostel-report-tabs">
          {REPORT_TABS.map((tab) => {
            // Permission check
            if (!hasAccess(tab.path)) {
              return null;
            }

            const isActive = location.pathname === tab.path;

            return (
              <Link
                key={tab.path}
                to={tab.path}
                className={`hostel-report-tab ${isActive ? "active" : ""}`}
              >
                <i className={`${tab.icon} me-1`} />
                <span>{tab.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
